import React from "react";
import "./App.css";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
//import {Option} from './interfaces';
import { Maybe, Option, Question } from "./generated/graphql";
import { QuestionProps } from "./interfaces";

const QuestionComponent = (props: QuestionProps) => {
    const { data: question, onValueSelected } = props;
    const [value, setValue] = React.useState(0);

    const handleChange = (event: any) => {
        const optionId = parseInt(event.target.value);
        setValue(optionId);
        //this should be option.id
        if (onValueSelected) {
            onValueSelected(question.id, optionId);
        }
    };

    const options = question.options.nodes as Array<Maybe<Option>>;

    return (
        <div>
            <FormControl component="fieldset">
                {/* <FormLabel component="legend">{question.content}</FormLabel> */}
                <RadioGroup
                    row
                    aria-label="gender"
                    name="options"
                    value={value}
                    onChange={handleChange}>
                    {options.map((option: Maybe<Option>) => {
                        if (option) {
                            return (
                                <FormControlLabel
                                    key={option.id}
                                    value={option.id}
                                    control={<Radio />}
                                    label={option.content}
                                />
                            );
                        }
                    })}
                </RadioGroup>
            </FormControl>
        </div>
    );
};

export default QuestionComponent;
